import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { TranslateService } from '../../../../services/translate.service';
import { SegProfile } from '../../../../services/template-mappers/entities/risk-register-seg-group.model';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';

@Component({
    standalone: true,
    selector: 'app-seg-profile-header-widget',
    imports: [],
    templateUrl: './seg-profile-header-widget.component.html',
    styleUrl: './seg-profile-header-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegProfileHeaderWidgetComponent implements OnInit {
    @Input() profiles: SegProfile[] | null = null;
    @Input() showDescription = true;
    @Input() showContractors = true;

    readonly styles = SEG_STYLES;
    labels = {
        code: '', workers: '', contractors: '', shiftType: '', shiftLength: '', weeklyHours: '', noData: ''
    };

    constructor(private translateService: TranslateService) { }

    ngOnInit(): void {
        const t = (key: string) => this.translateService.getDynamicTranslation(key);
        this.labels = {
            code: t('SEG Code'),
            workers: t('No of Employees'),
            contractors: t('No of Contractors'),
            shiftType: t('Shift Type'),
            shiftLength: t('Shift Length (h)'),
            weeklyHours: t('Avg Weekly Hours'),
            noData: t('No Data Available')
        };
    }

    public trackByIndex = trackByIndex;
}
